function reviewSliders() {
   var slidersreview = document.getElementById('custom-reviews-slider');
   if (slidersreview) {
      var flkty = new Flickity(slidersreview, {
         wrapAround: true,
         fullscreen: true,
         contain: true,
         pageDots: false,
             prevNextButtons: false,
       cellAlign: 'left',
      });
      slidersreview.classList.add('spring-slider-visible');
   }
}
reviewSliders();